import TicketItem from "../ticket-item";
import { Filter } from "./base";

export default class SearchFilter extends Filter {
    public static shouldCreate(): boolean {
        return true;
    }

    private query: string | undefined;

    public constructor(query: string) {
        super({});
        this.query = query?.toLowerCase();
    }

    public shouldInclude(ticketItem: TicketItem): boolean {
        if (!this.query) {
            return true;
        }
        const { ticket, chat } = ticketItem;
        return chat.subject?.toLowerCase().includes(this.query)
            || ticket.description?.toLowerCase().includes(this.query)
            || chat.ticketNumber?.toString().includes(this.query)
            || chat.assignee?.name?.toLowerCase().includes(this.query)
            || chat.creator?.name?.toLowerCase().includes(this.query)
            || chat.lastMessage?.toLowerCase().includes(this.query)
            || false;
    }
}
